import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getCanonicalUrl } from "./seoConstants";

/**
 * Canonical link for the current or overridden path.
 * @param {Object} props
 * @param {string} [props.path] - Optional path override (without domain), e.g. "/resource/notion"
 */
const CanonicalTag = ({ path }) => {
  const { pathname } = useLocation();
  const canonicalUrl = useMemo(
    () => getCanonicalUrl(path ?? pathname),
    [path, pathname]
  );

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalTag;
